import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import { permission } from './router/permission';
import * as Api from './services/api'
import * as Label from './common/label'
import * as Map from './common/map'
import './style/reset.css'
if (JSON.parse(localStorage.getItem('userInfo'))?.userInfoVO) permission()
Vue.prototype.$http = Api
Vue.prototype.$label = Label
Vue.prototype.$map = Map
if(location.hostname.includes("whjoycity.cn")){
  Vue.prototype.$isWuHan = true;
}else {
  Vue.prototype.$isWuHan = false
}
Vue.config.productionTip = false

Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
